<template>
    <div>
        <form-input
            v-model="item.title"
            label="Title"
            :error-message="getError('title')"
            placeholder="Title"
        />

        <form-input
            v-model="item.from"
            label="From"
            :error-message="getError('from')"
            placeholder="From (use relative path eg. /volunteers)"
        />

        <div class="form-group col-12">
            <label>Status Code</label>
            <v-select
                v-model="item.statusCode"
                :options="statusCodeOptions"
                :reduce="option => option.value"
                :clearable="false"
                :class="{
                    'is-invalid': !!getError('statusCode')
                }"
            />

            <div class="invalid-feedback">
                {{ getError('statusCode') }}
            </div>
        </div>

        <form-input
            v-if="isToInputVisible"
            v-model="item.to"
            label="To"
            :error-message="getError('to')"
            placeholder="To (include http(s) if you want to redirect to an external site)"
        />
    </div>
</template>

<script>
import BaseForm from '@/components/elements/BaseForm';
import { StatusCodeOptions, StatusCodesToRequired } from '@/enums/redirects';

export default {
    extends: BaseForm,

    data() {
        return {
            statusCodeOptions: StatusCodeOptions
        };
    },

    computed: {
        isToInputVisible() {
            return StatusCodesToRequired.includes(this.item.statusCode);
        }
    }
};
</script>
